import script from "./boxDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./boxDetail.vue?vue&type=script&setup=true&lang=js"

import "./boxDetail.vue?vue&type=style&index=0&id=5dfb6db2&lang=css"

const __exports__ = script;

export default __exports__